import React from 'react'
import { NumberField } from 'react-admin'
import Exporter from 'services/csv/exporter'
import CatalogItemBaseList, {
  CatalogItemBaseListProps,
} from 'ui-shared/WrappedInputs/CatalogItemBaseList'

const LocationUpsellingList: React.FC<CatalogItemBaseListProps> = (props) => (
  <CatalogItemBaseList {...props} exporter={Exporter()}>
    <NumberField
      source="component.defaultCost"
      label="form.fields.defaultCost"
      sortable={false}
    />
  </CatalogItemBaseList>
)

export default LocationUpsellingList
